// extracted by mini-css-extract-plugin
export default {"speech":"Speech_speech__4VwJ9","--liquid":"Speech_--liquid__3krZW","--solid":"Speech_--solid__pWeck","content":"Speech_content__et5NG"};